import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  removeMachineStart,
  fetchGroupsStart,
  showNotificationWithTimeout
} from "store/actions";
import { LayoutContext } from "App/common/hoc/Layout";
import { NOTIFICATION_STATUS } from "App/componentsConfig";

function RemoveMachines(props) {
  const { lState, lMethods } = React.useContext(LayoutContext);
  const lStateRef = useRef();

  // const [group, setGroup] = React.useState(lState.popup.params.group);
  React.useEffect(() => {
    lMethods.updatePopupParams({
      execute: handleRemoveChange
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleRemoveChange() {
    let machineHasActiveVMs = false;
    if (props.virtAPIDown.show) {
      setTimeout(() => {
        props.showNotificationWithTimeout("dashboard", {
          status: NOTIFICATION_STATUS.failure.name,
          msg: "Server is unreachable at the moment. Please try later."
        });
      }, 500);
    } else {
      lState.popup.params.clientUUIDs.forEach(clientUUID => {
        if (
          props.vmsList.filter(vm => vm.client_uuid === clientUUID).length > 0
        ) {
          machineHasActiveVMs = true;
        } else {
          props.removeMachineStart(clientUUID, true);
        }
      });
      if (machineHasActiveVMs) {
        setTimeout(() => {
          props.showNotificationWithTimeout("dashboard", {
            status: NOTIFICATION_STATUS.success.name,
            msg:
              "Machine(s) to delete skipped as they have active virtual instance."
          });
        }, 500);
      }

      setTimeout(() => {
        props.fetchGroupsStart();
      }, 500);

      lState.popup.params.resetCheckList();
    }

    lMethods.closePopup();
  }

  return (
    <>
      <p>This will permanently delete the computer from your account.</p>
      <p>
        {" "}
        On removing the computer, all its backed up data and recovery points for
        file restore and image restore will be deleted. Any ongoing backup or
        restore operation will also be stopped. This operation is irreversible.
        However, the backup agent will not be removed from the computer.
      </p>
      <br></br>
      <p>
        <strong>Note</strong>: Machines with active virtual instance cannot be
        deleted. To delete such machines, please visit{" "}
        <strong>Virtualization</strong> page to delete the virtual instances
        first, and then proceed to delete the machine."
      </p>
      <br></br>
      <p>Are you sure you want to remove the computer(s) ?</p>
    </>
  );
}

function mapStateToProps(state) {
  return {
    groupsObj: state.dashboard.groups,
    vmsList: state.virtualization.vmsList,
    virtAPIDown: state.virtualization.serverDownPage
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      removeMachineStart,
      fetchGroupsStart,
      showNotificationWithTimeout
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(RemoveMachines);
